<div class="editor-panel">
    <!-- Toolbar -->
    <div class="editor-toolbar">
        <div class="toolbar-left">
            <p-select [options]="files()" [ngModel]="selectedFile()" (ngModelChange)="fileSelected.emit($event)" optionLabel="label" optionValue="value" placeholder="Select file" [style]="{ minWidth: '200px' }" appendTo="body" />
            <ng-content select="[editor-badge]" />
            @if (mode() !== 'code') {
                <span class="toolbar-divider"></span>
                <p-button icon="fa fa-up-right-and-down-left-from-center" [text]="true" size="small" pTooltip="Expand all" (onClick)="expandAll()" />
                <p-button icon="fa fa-down-left-and-up-right-to-center" [text]="true" size="small" pTooltip="Collapse all" (onClick)="collapseAll()" />
                <p-input-group class="search-group">
                    <input pInputText #searchInput (keyup.enter)="onSearchEnter(searchInput.value)" placeholder="Search config" type="text" />
                    <p-inputgroup-addon>
                        <p-button icon="pi pi-search" severity="secondary" variant="text" (onClick)="onSearchEnter(searchInput.value)" />
                    </p-inputgroup-addon>
                </p-input-group>
            }
        </div>
        <div class="toolbar-right">
            @if (editable()) {
                <p-button icon="fa fa-eye" [text]="true" size="small" pTooltip="View mode" (onClick)="setMode('view')" [disabled]="mode() === 'code' && !jsonValid()" [severity]="mode() === 'view' ? 'primary' : 'secondary'" />
                <p-button icon="fa fa-pencil" [text]="true" size="small" pTooltip="Edit mode" (onClick)="setMode('tree')" [disabled]="mode() === 'code' && !jsonValid()" [severity]="mode() === 'tree' ? 'primary' : 'secondary'" />
                <p-button icon="fa fa-code" [text]="true" size="small" pTooltip="Code mode" (onClick)="setMode('code')" [severity]="mode() === 'code' ? 'primary' : 'secondary'" />
                <span class="toolbar-divider"></span>
                <p-button icon="fa fa-save" [text]="true" size="small" pTooltip="Save" (onClick)="requestSave()" [disabled]="!canSave()" [loading]="saving()" severity="success" />
                <p-button icon="fa fa-undo" [text]="true" size="small" pTooltip="Revert changes" (onClick)="revert()" [disabled]="!canSave()" />
            }
            <p-button icon="fa fa-refresh" [text]="true" size="small" pTooltip="Reload" (onClick)="reloadRequested.emit()" />
            @if (!readonly()) {
                <span class="toolbar-divider"></span>
                <p-button icon="fa fa-plus" [text]="true" size="small" pTooltip="New config file" (onClick)="showNewDialog()" />
                @if (canDelete()) {
                    <p-button icon="fa fa-trash" [text]="true" size="small" pTooltip="Delete file" (onClick)="confirmDelete($event)" severity="danger" />
                }
            }
            @if (showTemplateButton()) {
                <span class="toolbar-divider"></span>
                <p-button icon="fa fa-file-edit" [text]="true" size="small" [pTooltip]="templateDisabled() ? 'Apply Template (device must be connected)' : 'Apply Template'" [disabled]="templateDisabled()" (onClick)="templateClick.emit()" severity="help" />
            }
            <p-button icon="fa fa-download" [text]="true" size="small" pTooltip="Download" (onClick)="download()" [disabled]="!config()" />
        </div>
    </div>

    <!-- Editor -->
    <div class="editor-wrapper" [class.loading]="loading()">
        @if (loading()) {
            <div class="editor-overlay">
                <i class="pi pi-spin pi-spinner"></i>
            </div>
        }
        @if (errorMessage()) {
            <div class="editor-error">
                <p-message severity="error">{{ errorMessage()! }}</p-message>
            </div>
        } @else {
            <json-editor #jsonEditor [options]="editorOptions" [data]="{}"></json-editor>
        }
    </div>

    <!-- Status bar -->
    <div class="editor-status">
        <div class="status-left">
            @if (lastSaved()) {
                <span class="status-item">Last saved: {{ lastSaved() | date: 'medium' }}</span>
            }
            @if (isDefault()) {
                <span class="status-item badge-default">Default</span>
            }
            @if (restartRequired()) {
                <span class="status-item badge-restart">Restart Required</span>
            }
        </div>
        <div class="status-right">
            @if (configPath()) {
                <span class="config-path">{{ configPath() }}</span>
            }
        </div>
    </div>
</div>

<!-- New Config Dialog -->
<p-dialog header="New Config File" [visible]="newDialogVisible()" (visibleChange)="newDialogVisible.set($event)" [modal]="true" [style]="{ width: '450px' }">
    <div class="new-config-form">
        <label for="newFileName">File name</label>
        <div class="filename-input-group">
            <input id="newFileName" type="text" pInputText [ngModel]="newFileName()" (ngModelChange)="newFileName.set($event)" placeholder="e.g. my_room" class="w-full" />
            @if (newFileSuffix()) {
                <span class="filename-suffix">{{ newFileSuffix() }}</span>
            }
        </div>
        @if (newFileName().trim() && newFileSuffix()) {
            <span class="filename-preview">{{ newFileName().trim().toLowerCase() }}{{ newFileSuffix() }}</span>
        }
    </div>
    <ng-template #footer>
        <p-button label="Cancel" severity="secondary" (onClick)="newDialogVisible.set(false)" />
        <p-button label="Create" icon="pi pi-plus" (onClick)="submitNewFile()" [disabled]="!newFileName().trim()" />
    </ng-template>
</p-dialog>

<!-- Delete confirmation -->
<p-confirmdialog />
